import { createUseStyles } from "react-jss";
export const useStyles = createUseStyles({
  slider: {
    overflow: "hidden",
    position: "relative",
    "& .carousel": {
      position: "relative",
      "& .carousel-indicators": {
        left: "auto",
        bottom: "10px",
        right: "auto",
        padding: "5px",
        margin: "0 auto",
        borderRadius: "50rem",
        justifySelf: "center",
        backdropFilter: "blur(8px)",
        boxShadow: "0 0 12px rgb(var(--black) / 0.03)",
        backgroundColor: "rgb(var(--black) / 0.7)",
        "& > button": {
          border: "0",
          marginBlock: "0",
          marginInline: "4px",
          width: "8px",
          height: "8px",
          borderRadius: "50rem",
          backgroundColor: "rgb(var(--white))",
          "&:hover": {
            animation: "org__pop 0.4s linear 1",
          },
        },
      },
      "& .carousel-inner": {
        height: "100%",
        "& .carousel-item": {
          "& > img": {
            objectFit: "contain",
            width: "100%",
            height: "100%",
          },
        },
      },
      "& .carousel-control-prev, & .carousel-control-next": {
        opacity: "1",
        width: "22px",
        height: "40px",
        filter: "unset",
        alignSelf: "center",
        backdropFilter: "blur(8px)",
        transition: "all 0.3s ease-in-out",
        backgroundColor: "rgb(var(--white))",
        border: "1px solid rgb(var(--light))",
        boxShadow: "0 0 12px rgb(var(--black) / 0.10)",
      },
      "& .carousel-control-prev": {
        left: "-1px",
        borderTopRightRadius: "4px",
        borderBottomRightRadius: "4px",
        "& .carousel-control-prev-icon": {
          width: "100%",
          height: "100%",
          backgroundSize: "18px",
          filter: "brightness(0)",
        },
      },
      "& .carousel-control-next": {
        right: "-1px",
        borderTopLeftRadius: "4px",
        borderBottomLeftRadius: "4px",
        "& .carousel-control-next-icon": {
          width: "100%",
          height: "100%",
          backgroundSize: "18px",
          filter: "brightness(0)",
        },
      },
    },
  },
});
